import { Component } from '@angular/core';

@Component({
    selector: 'anp-banner',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    standalone: false
})
export class BannerComponent {


}
